/* TODO: All of the constants should be defined at top following nameing convention */
const initialState = {
  current: {
    processing_load: 0,
    waiting_ratio: 0,
  },
  average: {
    processing_speed: 0,
    processing_time: 0,
    waiting_time: 0,
  },
  available: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'STATUS_RECIEVED':
      return action.status;
    case 'STATUS_RECIEVED_ERROR':
      return { ...state, available: false };
    default:
      return state;
  }
};

export const statusReceived = status => ({
  type: 'STATUS_RECIEVED',
  status: {
    average: status.average,
    current: status.current,
    available: true,
  },
});

export const statusReceivedError = () => ({
  type: 'STATUS_RECIEVED_ERROR',
  status: {
    available: false,
  },
});


export const getStatus = () => (dispatch, getState) => {
  const rq = getState().rmi.status();

  rq.then((status) => {
    dispatch(statusReceived(status));
  });
  rq.catch(() => {
    dispatch(statusReceivedError());
  });

  return rq;
};
